import React from 'react';
import BaseTabs from 'components/atoms/base-tabs';
import { Routes } from 'router/routes';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import NavigationHeader from 'components/molecules/navigation-header';

import s from './styles.module.scss';

import type { IBaseTab } from 'components/atoms/base-tabs';

interface IProps {
  campaignGuid: string;
  name?: string;
}

const SmsCampaignsPageHeader: React.FC<IProps> = ({ campaignGuid, name }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const tabs: IBaseTab<string>[] = [
    {
      key: Routes.smsCampaignGuid(campaignGuid),
      label: t('labels.campaign'),
    },
    {
      key: Routes.smsCampaignResponses(campaignGuid),
      label: t('labels.responses'),
    },
    {
      key: Routes.smsCampaignSummary(campaignGuid),
      label: t('labels.summary'),
    },
  ];

  const title = t('labels.smsCampaignsDashboard');
  const titleWithName = name ? `${title}: ${name}` : title;

  const handleChangeRoute = (tab: IBaseTab<string>) => {
    navigate(tab.key, { state: { name } });
  };

  return (
    <NavigationHeader goBackPath={Routes.smsCampaign} title={titleWithName}>
      <div className={s.controls}>
        <BaseTabs
          tabs={tabs}
          type="rounded"
          size="small"
          activeKey={location.pathname}
          onChange={handleChangeRoute}
        />
      </div>
    </NavigationHeader>
  );
};

export default SmsCampaignsPageHeader;
